<template>
  <div>
    <Header :title="title" :showBack="true"></Header>

    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          v-model="changeTicket.LineName"
          is-link
          readonly
          name="linePicker"
          label="线路"
          placeholder="点击选择线路"
          @click="showLinePickerFun"
        />
        <van-field
          v-model="changeTicket.StartNodeName"
          is-link
          readonly
          name="startNodePicker"
          label="上车点"
          placeholder="点击选择上车点"
          @click="showStartNodePicker = true"
        />
        <van-field
          v-model="changeTicket.ArrivalNodeName"
          is-link
          readonly
          name="arrivalNodePicker"
          label="下车点"
          placeholder="点击选择下车点"
          @click="showArrivalNodePicker = true"
        />
        <van-field
          v-model="changeTicket.ClassDate"
          is-link
          readonly
          name="classDatePicker"
          label="日期"
          placeholder="点击选择班次日期"
          @click="showClassDatePicker = true"
        />
        <van-field
          v-model="changeTicket.ClassTime"
          is-link
          readonly
          name="classTimePicker"
          label="时间"
          placeholder="点击选择班次日期"
          @click="showClassTimePicker = true"
        />
      </van-cell-group>

      <div style="margin: 16px; padding: 20px">
        <van-button round block type="primary" native-type="submit">
          改乘
        </van-button>
      </div>
    </van-form>

    <van-popup v-model="showLinePicker" position="bottom">
      <van-picker
        :columns="lineColumns"
        value-key="LineGID"
        @confirm="onLineConfirm"
        @cancel="showLinePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "车票改乘", //页面标题
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员对象
      changeTicket: JSON.parse(window.localStorage.getItem("changeTicket")), //车票数据
      showStartNodePicker: false,
      showArrivalNodePicker: false,
      showClassDatePicker: false,
      showClassTimePicker: false,
      showLinePicker: false, //是否显示线路选择
      lineColumns: [],
    };
  },
  watch: {},
  methods: {
    //调用线路选择
    showLinePickerFun() {
      if (this.lineColumns.length <= 0) {
        //调用接口获取线路数据
        let params = {
          OrganizationGID: this.operObj.OrganizationGID,
        };
        this.$http
          .post(this.$api.getGetCompLine, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              this.lineColumns = [];
              res.data.forEach((item) => {
                if (item.LineIsEnabled) {
                  this.lineColumns.push({ values: item.LineName,LineGID:item.LineGID });
                }
              });
              this.showLinePicker = true;
            }
          });
      } else {
        this.showLinePicker = true;
      }
    },
    onLineConfirm() {
      alert("1");
    },
    onSubmit() {},
  },
  mounted: function () {},
  created() {},
};
</script>

<style scoped lang="less">
</style>
